/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tentativi di risoluzione per problemi noti avvenuti durante l\'esecuzione dell\'applicativo. Azioni ammesse:  - *LOCK_USER*: bloccare un utente, disabilitandone l\'accesso - *RESEND_VERIFICATION_EMAIL*: avviare una nuova fase di verifica dell\'account di un utente - *RESEND_RECOVERY_EMAIL*: avviare una nuova fase di cambio password dell\'account di un utente
 */
export enum PlatformActionType {

    LOCK_USER = 'LOCK_USER',

    RESEND_VERIFICATION_EMAIL = 'RESEND_VERIFICATION_EMAIL',

    RESEND_RECOVERY_EMAIL = 'RESEND_RECOVERY_EMAIL'
}

